import React from 'react';
import { Sparkles, Target, Users } from 'lucide-react';

const Concept = () => {
  return (
    <section id="concept" className="py-16 md:py-24 bg-[#F8F8F5]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header - badge only */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center space-x-2 bg-[#4A6B96]/5 px-4 py-2 rounded-full">
            <Sparkles className="text-[#4A6B96]" size={20} />
            <span className="text-sm font-medium text-[#4A6B96]">Le Concept Esprit Ouest</span>
          </div>
        </div>

        {/* Founders photo on left + title & text on right */}
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center mb-16">
          <div className="rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/yspggh7f_ChatGPT%20Image%205%20mai%202026%2C%2017_31_53.png"
              alt="Elodie et Ludovic - Fondateurs Esprit Ouest"
              className="w-full h-72 md:h-[500px] object-cover"
            />
          </div>

          <div>
            <h2 className="text-3xl md:text-5xl font-bold text-[#4A6B96] mb-6 text-center">
              Bien plus qu'un simple<br />espace de travail
            </h2>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed">
              Esprit Ouest est une histoire d'entrepreneurs. Elodie et Ludovic, frère et sœur ont allié leurs compétences pour créer ces lieux de travail mais aussi de convivialité. Leurs convictions sont que le futur pour les cadres va s'écrire dans la liberté et l'indépendance. Télétravail, mais aussi de plus en plus d'activités libérales. De ce constat, ils ont pensé qu'il fallait accompagner ce changement en proposant des lieux permettant de concilier ces aspirations de liberté avec l'envie d'avoir des relations sociales dans un cadre raffiné et simple d'utilisation.
            </p>
          </div>
        </div>

        {/* Three Pillars */}
        <div className="grid md:grid-cols-3 gap-8">
          {/* Pillar 1 */}
          <div className="group p-8 rounded-xl bg-gradient-to-br from-white to-[#F8F8F5] border border-gray-200 hover:border-[#FFFFFF] hover:shadow-xl transition-all duration-300">
            <div className="w-14 h-14 bg-[#4A6B96] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
              <Target className="text-white font-bold" size={28} />
            </div>
            <h3 className="text-2xl font-bold text-[#4A6B96] mb-4">
              Design & Confort
            </h3>
            <p className="text-gray-600 leading-relaxed">Des espaces lumineux au design épuré, du mobilier disponible sur demande, et une ambiance inspirante pour stimuler votre créativité et votre bien-être au quotidien.


            </p>
          </div>

          {/* Pillar 2 */}
          <div className="group p-8 rounded-xl bg-gradient-to-br from-white to-[#F8F8F5] border border-gray-200 hover:border-[#FFFFFF] hover:shadow-xl transition-all duration-300">
            <div className="w-14 h-14 bg-[#4A6B96] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
              <Sparkles className="text-white font-bold" size={28} />
            </div>
            <h3 className="text-2xl font-bold text-[#4A6B96] mb-4">
              Flexibilité Maximale
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Contrats adaptables tout compris sans engagement long terme, espaces modulables selon 
              vos besoins. Vous évoluez, votre espace s'adapte. C'est ça, l'esprit Esprit Ouest.
            </p>
          </div>

          {/* Pillar 3 */}
          <div className="group p-8 rounded-xl bg-gradient-to-br from-white to-[#F8F8F5] border border-gray-200 hover:border-[#FFFFFF] hover:shadow-xl transition-all duration-300">
            <div className="w-14 h-14 bg-[#4A6B96] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
              <Users className="text-white font-bold" size={28} />
            </div>
            <h3 className="text-2xl font-bold text-[#4A6B96] mb-4">
              Communauté
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Rejoignez une communauté de professionnels engagés, avec du soutien entre pairs et un accompagnement personnalisé au besoin.
            </p>
          </div>
        </div>

        {/* Bottom Statement */}
        <div className="mt-16 text-center">
          <div className="inline-block p-8 rounded-2xl bg-[#4A6B96] max-w-4xl">
            <p className="text-2xl md:text-3xl text-white font-medium leading-relaxed">
              "Esprit Ouest, Indépendant, <span className="text-white font-bold font-bold">Ensemble</span> 
              ."
            </p>
          </div>
        </div>
      </div>
    </section>);

};

export default Concept;